module.exports = __webpack_public_path__ + "img/popuvideo.bc121203.svg";